import { Component } from '@angular/core';
import { NavController, NavParams, ActionSheetController, ToastController, Platform, LoadingController, Loading } from 'ionic-angular';

import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
//import { Http, Headers, RequestOptions } from '@angular/common/http';



import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { GlobalProvider } from "../../providers/global/global";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {BaseRequestOptions, RequestOptions, Headers, RequestOptionsArgs} from "@angular/http";

import { ImagePicker } from '@ionic-native/image-picker';
import { Base64 } from '@ionic-native/base64';
import { File } from '@ionic-native/file';
import { Transfer, TransferObject } from '@ionic-native/transfer';
import { FilePath } from '@ionic-native/file-path';
import { Camera } from '@ionic-native/camera';
import { Storage } from '@ionic/storage';

import { VisitorsRegMorePage } from '../visitors-reg-more/visitors-reg-more';
import { LoginPage } from '../login/login';
import { CalendarPage } from '../calendar/calendar';
import { VideoPage } from '../video/video';
import { DirectionsPage } from '../directions/directions';
import { VisitoreditPage } from '../visitoredit/visitoredit';



declare var cordova: any;

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  
  //imgPreview = '../../assets/imgs/upload.jpeg';
  datas = "";//[];
  registration = "";
  model = "";
  make = "";
  title = "Mr";
  name = "";
  surname = "";
  idNumber = "";
  mnumber = "";
  email = ""
  company = "";
  photoLocation = "";

  accessCode = "";
  authtoken = "";

  queAns = false;
  loading = true;
  error = false;



  constructor( 
      private formBuilder: FormBuilder,  
      public navCtrl: NavController, 
      private toastCtrl: ToastController, 
      public navParams: NavParams,     
      public http: HttpClient,    
      private imagePicker: ImagePicker,    
      private base64: Base64,
      private camera: Camera, 
      private transfer: Transfer, 
      private file: File, 
      private filePath: FilePath, 
      public actionSheetCtrl: ActionSheetController, 
      public platform: Platform, 
      public loadingCtrl: LoadingController,
      private storage: Storage,
      public global: GlobalProvider
    ) {

      this.storage.get('accesscode').then((val) => {
        console.log('acc = '+val);
        this.accessCode = val;
        this.storage.get('Authorization').then((val1) => {
          console.log('acc = '+this.accessCode);
          this.authtoken = val1;
          this.getVisitorInfo()
        });
        
      });
      
    
  }

  logout(){
    this.storage.clear();
    this.navCtrl.push(LoginPage);
  }


  redirectPage(params:string){
    console.log('params = '+params);
    if(params == 'LoginPage')
      this.navCtrl.push(LoginPage);
    else if(params == 'CalendarPage')
      this.navCtrl.push(CalendarPage);
    else if(params == 'VideoPage')
      this.navCtrl.push(VideoPage);
    else if(params == 'DirectionsPage')
      this.navCtrl.push(DirectionsPage);
    else if(params == 'VisitoreditPage')
      this.navCtrl.push(VisitoreditPage, {
        accesscode:this.accessCode 
      });
  }
  /** regiasteration upload */
  getVisitorInfo(){

    
    
    const httpOptions = {
      headers: new HttpHeaders({
        //'Content-Type':  'application/json',
        //'Accept': 'application/json',
        'Authorization':this.authtoken//'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJzRzhNUU1DayIsInNjb3BlcyI6WyJST0xFX1ZJU0lUT1IiXSwiZXhwIjoxNTQ1NDkyMDEwfQ.v4-JvO9di-g-CuP73ufk8WQYc_5dS13snRXEMD5DlI0ca4BeIf9b6W_iWyU2F7hwyKoKJ_rJODnw1yG7fG75Kg'
      })
    };

    const url = this.global.baseUrl+"api/visitor?verificationCode="+this.accessCode;

    

    this.http.get(url, httpOptions)//requestOpt)
      .subscribe((data:any) => {
        
          if(data.error == true){
            
            this.loading = false;
            this.error = true;
            //console.log(data.errorList[0].description);
            let toast = this.toastCtrl.create({
              message: data.errorList[0].description,
              duration: 5000,
              position: 'bottom',
              showCloseButton:true,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              if(data.errorList[0].description == 'VISITOR_INFO_NOT_FOUND'){
                this.storage.clear();
                this.navCtrl.push(LoginPage);
              }
              console.log('Dismissed toast!');
            });
          
            toast.present();

          }else{
            //console.log(data.visitorDTO);
            this.loading = false;
            this.error = false;
            this.datas = data.visitorDTO;
            //console.log('------------*---------------');
            //console.log(this.datas);
            /*
            this.name = data.visitorDTO.name;
            this.surname = data.visitorDTO.surname;
            this.title = data.visitorDTO.title;
            this.idNumber = data.visitorDTO.idNumber;
            this.email = data.visitorDTO.email;
            this.mnumber = '+27'+data.visitorDTO.phones[0].number;
            this.company = data.visitorDTO.company;
            this.photoLocation = data.visitorDTO.photoLocation;*/
            this.mnumber = '+27'+data.visitorDTO.phones[0].number;
            this.registration = data.visitorDTO.cars[0].registration;
            this.model = data.visitorDTO.cars[0].model;
            this.make = data.visitorDTO.cars[0].make;

            //console.log(this.registration+' mod '+this.model);

            this.storage.set('usermail',data.visitorDTO.email);
            this.queAns = data.visitorDTO.answered;
            console.log(this.queAns);
            

            /*let toast = this.toastCtrl.create({
              message: 'Visitor created successfully!.',
              duration: 3000,
              position: 'bottom',
              showCloseButton:false,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              console.log('Dismissed toast');
            });
          
            toast.present();*/
          }
        }, error => {
        console.log(error);
        
        this.loading = false;
        this.error = true;
        let toast = this.toastCtrl.create({
          message: 'Error!.',
          duration: 5000,
          position: 'bottom',
          showCloseButton:false,
          closeButtonText:'Close'
        });

        toast.onDidDismiss(() => {
          console.log('Dismissed toast');
        });
      
        toast.present();

        
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts